import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findInfoCard = (headers, idNumber) => {
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/person/card/${idNumber}`, {
        headers,
    });
};
export const findPersonInfos = (headers, params) => {
    let query = buildQuery(params, []);
    if (params.filters.idNumber.value) {
        query += `&idNumber=${params.filters.idNumber.value?.trim()}`;
    }
    if (params.filters.fullName.value) {
        query += `&fullName=${params.filters.fullName.value?.trim().toLowerCase()}`;
    }
    if (params.filters.birthDate.value) {
        query += `&birthDate=${formatDate(params.filters.birthDate.value)}`;
    }
    if (params.filters.phoneNumber.value) {
        query += `&phoneNumber=${params.filters.phoneNumber.value?.trim().toLowerCase()}`;
    }
    if (params.filters.addressId.value) {
        query += `&addressId=${params.filters.addressId.value}`;
    }
    if (params.filters.idNumberOld.value) {
        query += `&idNumberOld=${params.filters.idNumberOld.value}`;
    }
    if (params.filters.fatherName.value) {
        query += `&fatherName=${(params.filters.fatherName.value)}`;
    }
    if (params.filters.fatherIdNumber.value) {
        query += `&fatherIdNumber=${(params.filters.fatherIdNumber.value)}`;
    }
    if (params.filters.motherName.value) {
        query += `&motherName=${(params.filters.motherName.value)}`;
    }
    if (params.filters.motherIdNumber.value) {
        query += `&motherIdNumber=${(params.filters.motherIdNumber.value)}`;
    }
    if (params?.filters?.fromDate?.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params?.filters?.toDate?.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/person/list${query}`, {
        headers,
    });
};

export const findHistoryInfoPerson = (headers, idNumber) => {
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/person/change-detail/1/${idNumber}`, {
        headers,
    });
};

export const findHistoryInfoCard = (headers, idNumber) => {
    return axios.get(`${process.env.REACT_APP_INFO_API_URL}/person/change-detail/4/${idNumber}`, {
        headers,
    });
};
